import WidgetProvider from "./WidgetProvider"

export default (props) => (WidgetComponent) => {
    WidgetProvider.registerWidget(props, WidgetComponent);
    return WidgetComponent;
}